import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class List extends React.Component {

    @observable records = null;

    constructor(props) {
        super(props);
        this.init();
    }

    init = async () => {
        this.records = await store.model.Governance.find({ order: 'id desc' });
    };

    create = () => this.props.history.push('/admin/governance/create');

    render() {
        if (!this.records) return '...';

        return <>
            <p>Статичные страницы</p>
            <p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
            <Table records={this.records} rootPath="/admin" path="governance">
                <Column property="name" label="ФИО" />
            </Table>
        </>;
    }

}
